import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    uid: localStorage.getItem("uid"),
    authenticated: localStorage.getItem("uid") !== null ? true : false
  },
  mutations: {
    setUid(state, uid) {
      if (uid !== null) {
        localStorage.setItem("uid", uid);
      } else {
        localStorage.removeItem("uid");
      }
      state.uid = uid;
      state.authenticated = uid !== null ? true : false;
    }
  },
  actions: {},
  getters: {}
});
